import React from 'react';
import { t } from 'i18next';
import { cnMerge } from '@/utils/cnMerge';
import type { InstructionsDirectory } from '@/redux/slices/Doctors';

export interface InstructionsFolderSidebarProps {
    roots: InstructionsDirectory[];
    renderTreeNode: (dir: InstructionsDirectory, depth: number) => React.ReactNode;
    className?: string;
}

export default function InstructionsFolderSidebar({
    roots,
    renderTreeNode,
    className,
}: InstructionsFolderSidebarProps) {
    return (
        <div
            className={cnMerge(
                'border border-solid border-border-default rounded-lg overflow-y-auto bg-muted/30 p-2 flex flex-col',
                'w-56 shrink-0',
                className,
            )}
        >
            <div className="text-md font-medium text-text-primary mb-2 border-0 border-b-[1px] border-solid border-border-default pb-2">
                {t('Doctors.InstructionsFolders')}
            </div>
            <div className="space-y-0 select-none">
                {roots.length === 0 ? (
                    <p className="text-sm text-text-secondary py-2 pl-2">{t('Doctors.NoInstructionsFolders')}</p>
                ) : (
                    <div className={cnMerge('relative border-l border-border-default', 'ml-2.5')}>
                        {roots.map((dir) => renderTreeNode(dir, 0))}
                    </div>
                )}
            </div>
        </div>
    );
}
